import React from 'react';
import {
  colors,
  createStyles,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  withStyles,
  InputLabel,
  Theme,
} from '@material-ui/core';
import { Field } from 'redux-form';
import { required } from 'app/util/validators';

const styles = (theme: Theme) => createStyles({
  selected: {
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.secondary.main,
      '& span': {
        color: '#ffffff',
      },
    },
  },
  radioLabel: {
    marginTop: 5,
    marginRight: 0,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      paddingTop: 2,
      paddingBottom: 2,
      borderBottom: `1px solid ${colors.grey[300]}`,
    },
  },
  // Only applied when row=true: side-by-side options otherwise sit close enough to almost touch.
  radioLabelRow: {
    marginRight: 24,
  },
  radioWrapper: {
    marginTop: 15,
    '& label': {
      marginRight: 0,
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        marginLeft: 0,
        '& span:last-child': {
          marginLeft: 10,
        },
      },
    },
    // '& label' above is a class+element selector, more specific than the plain .radioLabelRow
    // class alone, so it always won and silently ate that override - this re-declares it at
    // matching specificity (via JSS's $ref to the radioLabelRow rule) so it actually applies.
    '& label$radioLabelRow': {
      marginRight: 24,
    },
    '& label.selected span': {
      [theme.breakpoints.down('sm')]: {
        '& span': {
          color: '#ffffff',
        },
      },
    },
  },
});

const renderRadioGroup = (props) => {
  const { classes } = props;
  return (
    <FormControl fullWidth>
      <RadioGroup row={props.row} {...props.input}>
        {props.options.map((option, index) => {
          const className = [
            classes.radioLabel,
            props.input.value === option.value ? classes.selected : null,
            props.row ? classes.radioLabelRow : null,
          ].filter(Boolean).join(' ');

          return (
            <FormControlLabel
              key       = {index}
              control   = {<Radio color="primary" />}
              label     = {option.title}
              value     = {option.value}
              className = {className}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export const RadioField = withStyles(styles)(({ ...props }: any) => {
  const { classes } = props;
  return (
    <div className={classes.radioWrapper}>
      { props.label ? <InputLabel shrink>{ props.label }</InputLabel> : null }
      <Field
        classes   = {props.classes}
        component = {renderRadioGroup}
        name      = {props.name}
        onChange  = {props.onChange}
        options   = {props.options}
        row       = {props.row}
        validate  = {[required]}
      />
    </div>
  );
});
